<template>
<div>
    <h2><i class="fa fa-fw fa-lg fa-calculator"></i> Rechnungsnummernkreis</h2>
    <p></p>
    <div class="v-form-partial">
        <div>
            <fieldset>
                <div v-if="!loading" class="row">
                    <div class="col-md-6 col-sm-12">
                        <create-invoice-prefix :operator-id="operatorId"></create-invoice-prefix>
                    </div>
                </div>

                <table v-if="!loading" class="table table-striped table-bordered table-hover dataTable">
                    <thead>
                        <th class="table-column-title">{{ $label('operator.invoice_prefix.name') }}</th>
                        <th class="table-column-title">{{ $label('operator.invoice_prefix.from') }}</th>
                        <th class="table-column-title">{{ $label('operator.invoice_prefix.until') }}</th>
                        <th class="table-column-title">{{ $label('operator.invoice_prefix.prefix') }}</th>
                        <th class="table-column-title">{{ $label('operator.invoice_prefix.export_marker') }}</th>
                        <th class="table-column-title">{{ $label('operator.invoice_prefix.start_number') }}</th>
                        <th class="table-column-title">{{ $label('operator.invoice_prefix.end_number') }}</th>
                        <th class="table-column-title">{{ $label('operator.invoice_prefix.next_number') }}</th>
                        <th class="table-column-title">{{ $label('operator.invoice_prefix.increment_step') }}</th>
                        <!-- <th class="table-column-title"></th> -->
                    </thead>
                    <tbody>
                        <tr v-for="invoicePrefix in invoicePrefixes">
                            <th class="v-table">{{ invoicePrefix.name }}</th>
                            <th class="v-table">{{ invoicePrefix.from }}</th>
                            <th class="v-table">{{ invoicePrefix.until }}</th>
                            <th class="v-table">{{ invoicePrefix.prefix }}</th>
                            <th class="v-table">{{ invoicePrefix.export_marker }}</th>
                            <th class="v-table">{{ invoicePrefix.start_number }}</th>
                            <th class="v-table">{{ invoicePrefix.end_number }}</th>
                            <th class="v-table">{{ invoicePrefix.next_number }}</th>
                            <th class="v-table">{{ invoicePrefix.increment_step }}</th>
                            <!-- <th class="v-table text-center">
                                <div class="btn-group">
                                    <a class="btn btn-sm btn-default text-default">
                                        <i class="fa fa-lg fa-fw fa-edit"></i>
                                    </a>
                                    <a class="btn btn-sm btn-danger is-disabled text-default">
                                        <i class="fa fa-lg fa-fw fa-ban"></i>
                                    </a>
                                </div>
                            </th> -->
                        </tr>
                    </tbody>
                </table>

                <div v-if="loading" class="col-xs-12 text-center">
                    <img :src="require('@/assets/img/loader-green.svg')">
                </div>

                <!-- <section class="col col-xs-8">
                    <label class="label">Auswahl</label>
                    <label class="radio">
                        <input id="std_number_range" type="radio" name="own_invoice_range" value="no" ><i></i> Standard-Nummernkreis
                    </label>
                    <label class="radio ">
                        <input id="own_number_number" type="radio" name="own_invoice_range" value="yes" ><i></i> Eigener Nummernkreis
                    </label>
                </section>
                <section id="next_invoice_number_block" class="col col-xs-4 ">
                    <label class="label"> Nächste Nummer</label>
                    <label class="input">
                        <input id="next_invoice_number" type="text" value="302" name="next_invoice_number">
                    </label>
                </section> -->
            </fieldset>
        </div>
    </div>
</div>
</template>

<script>
import Api from '@/api';
import CreateInvoicePrefix from '@/components/Operator/InvoiceSettings/CreateInvoicePrefix.vue';

export default {
    props: ['operatorId'],

    components: {
        CreateInvoicePrefix,
    },

    data() {
        return {
            loading: false,
            invoicePrefixes: [],
        }
    },

    mounted() {
        this.loadData();
        this.listenEvents();
    },

    methods: {
        loadData() {
            this.getOperatorInvoicePrefixes();
        },

        getOperatorInvoicePrefixes(successCallback) {
            if (this.loading) {
                return;
            }

            this.loading = true;

            let endpoint = 'partners/demo_partner/operators/' + this.operatorId + '/invoice-prefixes';

            Api().get(endpoint)
                .then((success) => {
                    this.invoicePrefixes = success.data.data;
                    if (typeof successCallback == 'function') {
                        successCallback();
                    }
                })
                .catch((error) => {
                    //
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        listenEvents() {
            Event.$on('refreshInvoicePrefixes', (successCallback) => {
                this.getOperatorInvoicePrefixes(successCallback);
            });
        },
    },

    watch: {
        operatorId(operatorId) {
            this.loadData();
        }
    }
}
</script>
